import { AllEventsAnalyticsTotalsSnapshotSchema } from "@redotech/redo-analytics-common/analytics";
import * as z from "zod";

export const getAllEventsAnalytics = {
  name: "getAllEventsAnalytics",
  input: z.object({
    numUnits: z.number().positive(),
    startDate: z.date(),
    page: z.number().positive().optional(),
    pageSize: z.number().positive().optional(),
  }),
  output: z.object({
    current: z.array(AllEventsAnalyticsTotalsSnapshotSchema),
    previous: z.array(AllEventsAnalyticsTotalsSnapshotSchema),
    totalCount: z.number().optional(),
  }),
};
